import * as THREE from 'three';
import { fxUniforms, FOG_FRAG, FOG_VERT } from './common';

/** A bounded, GPU-animated energy ribbon. Only drawn while a merge is previewed. */
export class MergeGuide {
  readonly from = new THREE.Vector3();
  readonly to = new THREE.Vector3();
  readonly color = new THREE.Color();
  readonly mesh: THREE.Mesh;

  constructor(scene: THREE.Scene) {
    const material = new THREE.ShaderMaterial({
      uniforms: { ...fxUniforms, uFrom: { value: this.from }, uTo: { value: this.to }, uColor: { value: this.color } },
      transparent: true, depthWrite: false, blending: THREE.AdditiveBlending,
      vertexShader: /* glsl */ `
        uniform vec3 uFrom, uTo;
        varying vec2 vUv;
        ${FOG_VERT}
        void main() {
          vUv = uv;
          vec3 p = mix(uFrom, uTo, uv.x);
          p.y += sin(uv.x * 3.141593) * 0.22;
          vec4 mv = viewMatrix * vec4(p, 1.0);
          vec2 direction = (viewMatrix * vec4(uTo - uFrom, 0.0)).xy;
          direction /= max(length(direction), 0.0001);
          mv.xy += vec2(-direction.y, direction.x) * (uv.y - 0.5) * 0.07;
          FOG_FROM_MV(mv)
          gl_Position = projectionMatrix * mv;
        }`,
      fragmentShader: /* glsl */ `
        uniform vec3 uColor;
        uniform float uTime;
        varying vec2 vUv;
        ${FOG_FRAG}
        void main() {
          float edge = pow(1.0 - abs(vUv.y * 2.0 - 1.0), 2.0);
          float flow = pow(max(0.0, sin(vUv.x * 26.0 - uTime * 9.0)), 8.0);
          float ends = smoothstep(0.0, 0.08, vUv.x) * (1.0 - smoothstep(0.92, 1.0, vUv.x));
          gl_FragColor = vec4(uColor * edge * ends * (0.35 + flow * 2.0) * fogKeep(), 1.0);
        }`,
    });
    this.mesh = new THREE.Mesh(new THREE.PlaneGeometry(1, 1, 24, 1), material);
    this.mesh.frustumCulled = false;
    this.mesh.renderOrder = 4;
    this.mesh.visible = false;
    scene.add(this.mesh);
  }
}
